(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ywh-custom-content"] && !Shopify.designMode) return;
  try {
    
  // --- LÓGICA DE INYECCIÓN (Solo Vistos Recientemente) ---
  document.addEventListener('DOMContentLoaded', () => {
    
    // --- Helper para construir la rejilla ---
    function buildGridHtml(products) {
      let newGridHtml = '';
      products.forEach(product => {
        let title = product.title.replace(/"/g, '&quot;');
        let url = product.url.startsWith('/') ? product.url : `/${product.url}`;
        let image = product.image || product.featured_image;

        if (image) {
          newGridHtml += `
            <li class="ywh-content-grid-item">
              <a href="${url}">
                <img src="${image}" alt="${title}" width="200" height="200" loading="lazy" 
                     style="aspect-ratio: 1/1; object-fit: cover; width: 100%; height: auto; border: 1px solid #eee; border-radius: 4px; margin-bottom: 5px;">
                <span>${product.title}</span>
              </a>
            </li>
          `;
        } else {
          newGridHtml += `
            <li class="ywh-content-grid-item">
              <a href="${url}">
                <div style="aspect-ratio: 1/1; width: 100%; border: 1px solid #eee; border-radius: 4px; margin-bottom: 5px;">
                  ${window.ywhPlaceholderSvg}
                </div>
                <span>${product.title}</span>
              </a>
            </li>
          `;
        }
      });
      return newGridHtml;
    }

    // Encontrar el bloque dinámico
    const injectorBlock = document.querySelector('[data-recently-viewed-injector="true"]');
    if (!injectorBlock) return; // No hay bloque de Vistos Recientemente activado

    const targetGridSelector = injectorBlock.dataset.injectorGrid;
    const targetHeaderSelector = injectorBlock.dataset.injectorHeader;
    const targetGrid = document.querySelector(targetGridSelector);
    const targetHeader = document.querySelector(targetHeaderSelector);

    if (!targetGrid || !targetHeader) {
      if(targetGrid) targetGrid.style.visibility = 'visible'; // Asegurarse de mostrarlo si algo falla
      return; 
    }

    // --- PRIORIDAD 1: Vistos Recientemente ---
    const viewedHandles = JSON.parse(localStorage.getItem('ywh_recently_viewed'));

    if (viewedHandles && viewedHandles.length > 0) {
      const requests = viewedHandles.slice(0, 4).map(handle => 
        fetch(`/products/${handle}.js`).then(res => res.json())
      );

      Promise.all(requests)
        .then(products => {
          if (products && products.length > 0) {
            targetGrid.innerHTML = buildGridHtml(products);
            targetHeader.innerHTML = 'Vistos Recientemente';
          }
        })
        .catch(e => {
          console.error('YWH Recently Viewed Fetch Error:', e);
          // Si falla, el contenido Liquid (Carrito/Default) ya está ahí, solo lo mostramos.
        })
        .finally(() => {
          // *** ¡LA SOLUCIÓN! ***
          // No importa si tuvo éxito o falló, revelamos la columna.
          targetGrid.style.visibility = 'visible';
        });

      return; // Prioridad 1 (JS) en proceso...
    } else {
      // *** ¡LA SOLUCIÓN! ***
      // No hay "Vistos Recientemente", así que revelamos el contenido Liquid (Carrito/Default) al instante.
      targetGrid.style.visibility = 'visible';
    }

    // --- PRIORIDAD 2 y 3: ---
    // Si no se cumple P1, el contenido Liquid (Carrito o Por Defecto) se revela.

  });

  } catch(e) { console.error(e); }
})();
})();
